import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import styled, { createGlobalStyle } from "styled-components";
import { palette } from "../../../assets/styles/Palette";
import AtomPersonaLoader from "../../Global/components/atoms/AtomPersonaLoader";
import { Button } from "../../../assets/styles/ButtonStyle";
import images from "../../../assets/styles/Images";
import PopupWrap from "../../../assets/styles/Popup";
import Markdown from "markdown-to-jsx";
import {
  ContentsWrap,
  MainContent,
  TabWrapType4,
  TabButtonType4,
  TabWrapType5,
  TabButtonType5,
  TabContent5,
  TabContent5Item,
  BgBoxItem,
  DropzoneStyles,
  Title,
  ListBoxGroup,
  BoxWrap,
  InterviewPopup,
} from "../../../assets/styles/BusinessAnalysisStyle";
import {
  H4,
  H3,
  Sub3,
  Body1,
  Body2,
  Body3,
  Caption1,
  InputText,
} from "../../../assets/styles/Typography";
import {
  FormBox,
  CustomTextarea,
  CustomInput,
  SelectBox,
  SelectBoxItem,
  SelectBoxTitle,
  SelectBoxList,
} from "../../../assets/styles/InputStyle";
import "react-dropzone-uploader/dist/styles.css";
import { useDynamicViewport } from "../../../assets/DynamicViewport";
import MoleculeFileUpload from "../components/molecules/MoleculeFileUpload";
import MoleculeAnalysisCard from "../components/molecules/MoleculeAnalysisCard";
import MoleculeCreateDisplayHeader from "../components/molecules/MoleculeCreateDisplayHeader";
import OrganismDisplayViewEduMealPreview from "../../Global/components/organisms/OrganismDisplayViewEduMealPreview";

import {
  IS_LOGGED_IN,
  AUTODISPLAY_SELECTED_DEVICE,
  AUTODISPLAY_DESIGN_GENERATOR,
  AUTODISPLAY_SELECTED_CONTENT,
  CUSTOMER_ID,
} from "../../AtomStates";
import { useAtom } from "jotai";
import {
  createEduViewOnServer,
  updateEduViewOnServer,
  AutoDisplayFileAnalysisMultimodalRequest,
  AutoDisplayFileAnalysisRequest,
  AutoDisplayContentGeneratorRequest,
  AutoDisplayDesignGeneratorRequest,
  getUserMemberType,
  AutoDisplayFileAnalysisMealRequest,
} from "../../../utils/indexedDB";
import file1 from "../../../assets/files/2025 여름철 물놀이 안전 수칙 및 화재 대피 요령 안내 가정통신문.pdf";
import file2 from "../../../assets/files/2025학년도 졸업앨범 주요 내용 안내 가정통신문.pdf";
import file3 from "../../../assets/files/[붙임1] 기후과학클래스 모집 포스터.jpg";
import file4_1 from "../../../assets/files/2025 융합과학교육원 본원 메이커 발명 캠프 신청 안내.pdf";
import file4_2 from "../../../assets/files/2025 융합과학교육원 본원 메이커 발명 캠프 포스터.png";
import file5 from "../../../assets/files/2025학년도 한성과학고등학교 발명교육센터 발명심화・특별과정 운영 계획.pdf";
import B_food_1 from "../../../assets/images/Background/B_food_1.png";
import B_food_2 from "../../../assets/images/Background/B_food_2.png";

const GlobalStyle = createGlobalStyle`  
  .markdown-body p {
    margin-bottom: 12px !important;
  }
`;

const designConceptsData = [
  {
    id: "healthy",
    name: "건강식",
    image: B_food_1,
  },
  {
    id: "happy",
    name: "행복식",
    image: B_food_2,
  },
];

const PageCreateEducationContent = () => {
  const navigate = useNavigate();

  const [isLoggedIn] = useAtom(IS_LOGGED_IN);
  const [selectedDevice] = useAtom(AUTODISPLAY_SELECTED_DEVICE);
  const [autoDisplayDesignGenerator, setAutoDisplayDesignGenerator] = useAtom(
    AUTODISPLAY_DESIGN_GENERATOR
  );
  // UI 상태 관리
  const [showPopupSave, setShowPopupSave] = useState(false);
  const [showPopupError, setShowPopupError] = useState(false);
  const [activeTab, setActiveTab] = useState(1);
  const [completedSteps, setCompletedSteps] = useState([]);
  const [businessDescription, setBusinessDescription] = useState("");
  const [contentTarget, setContentTarget] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingReport, setIsLoadingReport] = useState(false);
  const [showPopupFileSize, setShowPopupFileSize] = useState(false);
  const [toolSteps, setToolSteps] = useState(0);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [fileNames, setFileNames] = useState([]);
  const [interviewModeType, setInterviewModeType] = useState("conceptBoard");
  const [isLoadingPreset, setIsLoadingPreset] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [showCreatePersonaPopup, setShowCreatePersonaPopup] = useState(false);
  const [showCreditPopup, setShowCreditPopup] = useState(false);
  const [selectedDesignConcepts, setSelectedDesignConcepts] = useState([]);
  const [dropUpStates, setDropUpStates] = useState({
    customerList: false,
  });
  const [selectBoxStates, setSelectBoxStates] = useState({
    customerList: false,
  });
  const [selectedPurposes, setSelectedPurposes] = useState({
    customerList: "",
  });
  const [isLoadingTemplate, setIsLoadingTemplate] = useState(false);
  const [showTemplateSelection, setShowTemplateSelection] = useState(false);
  const [showPreviewPopup, setShowPreviewPopup] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [showTemplatePreview, setShowTemplatePreview] = useState(false);
  const [templateToPreview, setTemplateToPreview] = useState(null);
  const [autoDisplayFileAnalysis, setAutoDisplayFileAnalysis] = useState(null);
  const [timeStamp, setTimeStamp] = useState(null);
  const [allDesignResponses, setAllDesignResponses] = useState([]); // 모든 디자인 응답 저장
  const [selectedTemplateData, setSelectedTemplateData] = useState(null);
  const [customerId, setCustomerId] = useAtom(CUSTOMER_ID);
  const [nutritionMessage, setNutritionMessage] = useState("");
  const [autoDisplayContentGeneratorMeal, setAutoDisplayContentGeneratorMeal] =
    useState(null);

  const [
    autoDisplayContentGeneratorMarkdown,
    setAutoDisplayContentGeneratorMarkdown,
  ] = useState([]);
  const [
    autoDisplayContentGeneratorTitle,
    setAutoDisplayContentGeneratorTitle,
  ] = useState([]);
  const [autoDisplayContentGeneratorJson, setAutoDisplayContentGeneratorJson] =
    useState(null);
  const [contentsPurpose, setContentsPurpose] = useState(null);

  const [selectedMessage, setSelectedMessage] = useState(null);
  const [selectedTargetAudience, setSelectedTargetAudience] = useState(null);

  // 템플릿 데이터
  const templateData = [
    // {
    //   id: 1,
    //   title: "고대비 밝은 양식 디자인",
    //   description: "밝고 간결하게 정보를 전달하는 기본형 디자인 ",
    //   category: "모던 게시판형",
    //   image: "/images/template1.jpg", // 실제 이미지 경로로 변경
    //   location: "4층 도서자료실(지금실내네비)",
    // },
    // {
    //   id: 2,
    //   title: "심플한 직관 양식 디자인",
    //   description: "시선을 집중시키는 어두운 배경의 정보전달형 디자인 ",
    //   category: "심플 플로우형",
    //   image: "/images/template2.jpg", // 실제 이미지 경로로 변경
    //   location: "4층 도서자료실(지금실내네비)",
    // },
    // {
    //   id: 3,
    //   title: "아이콘 인포그래픽 양식 디자인",
    //   description: "부드럽고 신뢰감 있는 분위기의 파란색 계열 디자인 ",
    //   category: "엥글 보드형",
    //   image: "/images/template3.jpg", // 실제 이미지 경로로 변경
    //   location: "4층 도서자료실(지금실내네비)",
    // },
  ];

  useDynamicViewport("width=1280");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const checkMemberType = async () => {
      const accessToken = sessionStorage.getItem("accessToken");
      const userMemberType = await getUserMemberType(accessToken);
      const lastUrl = sessionStorage.getItem("lastUrl");

      if (
        (lastUrl === "/CreateApiContent" || lastUrl === "/ApiDashBoard") &&
        userMemberType.member_type === 99
      ) {
        navigate("/Admin");
      }

      if (userMemberType.member_type === 11) {
        navigate("/DashBoard");
      } else if (userMemberType.member_type === 12) {
        navigate("/CustomerManage");
      } else if (userMemberType.member_type === 21) {
        navigate("/ApiDashBoard");
      } else if (userMemberType.member_type === 22) {
        navigate("/CustomerManage");
      }
    };

    checkMemberType();
  }, []);

  useEffect(() => {
    if (showToast) {
      document.body.style.overflow = "hidden";
      document.body.style.paddingRight = "15px";
    } else {
      document.body.style.overflow = "auto";
      document.body.style.paddingRight = "0";
    }

    return () => {
      document.body.style.overflow = "auto";
      document.body.style.paddingRight = "0";
    };
  }, [showToast]);

  const handleNextStep = (currentStep) => {
    setCompletedSteps([...completedSteps, currentStep]);
    setActiveTab(currentStep + 1);
    setShowPopupError(false);
  };

  const abortControllerRef = useRef(null);

  const handleSubmitConcept = async () => {
    if (autoDisplayFileAnalysis) {
      handleNextStep(1);
      return;
    }
    abortControllerRef.current = new AbortController();
    const signal = abortControllerRef.current.signal;
    const timeStamp = new Date().getTime();
    setTimeStamp(timeStamp);
    // 2초 후 다음 단계로 이동 (API 호출 시뮬레이션)'
    handleNextStep(1);
    setToolSteps(2);
    setIsLoading(true);

    let response;

    try {
      // 파일 업로드를 통한 콘텐츠 생성
      const Data = {
        display_id: selectedDevice._id,
        files: uploadedFiles,
        time_stamp: String(timeStamp),
      };

      setFileNames(uploadedFiles.map((file) => file.name));

      let retryCount = 0;
      const maxRetries = 5;
      while (retryCount < maxRetries) {
        try {
          // 콘텐츠 생성을 위한 멀티모달 요청
          response = await AutoDisplayFileAnalysisMultimodalRequest(
            Data,
            isLoggedIn,
            signal
          );

          if (
            response &&
            response.response &&
            response.response.auto_display_file_analysis_multimodal &&
            response.response.auto_display_file_analysis_multimodal.title &&
            response.response.auto_display_file_analysis_multimodal.status &&
            response.response.auto_display_file_analysis_multimodal.detail &&
            response.response.auto_display_file_analysis_multimodal.message
          ) {
            // setAutoDisplayFileAnalysisMultimodal(
            //   response.response.auto_display_file_analysis_multimodal
            // );
            setAutoDisplayFileAnalysis(
              response.response.auto_display_file_analysis_multimodal
            );
            break; // 올바른 응답 형식이면 루프 종료
          }

          retryCount++;
        } catch (error) {
          console.error(`Retry ${retryCount + 1} failed:`, error);
          retryCount++;
          if (retryCount >= maxRetries) throw error;
        }
      }
    } catch (error) {
      console.error("콘텐츠 분석 중 오류 발생:", error);
      setShowPopupError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmitPurpose = async (isRegenerate = false) => {
    if ((autoDisplayContentGeneratorMeal || completedSteps.includes(3)) && !isRegenerate) {
      handleNextStep(2);
      return;
    }
    handleNextStep(2);
    setIsLoading(true);

    try {
      // 파일 업로드를 통한 콘텐츠 생성

      const Data = {
        type: "ad_education_meal_file_analysis",
        files: String(timeStamp),
      };

      let retryCount = 0;
      const maxRetries = 5;

      while (retryCount < maxRetries) {
        try {
          // 콘텐츠 생성을 위한 멀티모달 요청
          let response = await AutoDisplayFileAnalysisMealRequest(Data);

          if (
            response &&
            response.response &&
            response.response.ad_education_meal_file_analysis
          ) {
            setAutoDisplayContentGeneratorMeal(
              response.response.ad_education_meal_file_analysis
            );
            break; // 올바른 응답 형식이면 루프 종료
          }

          retryCount++;
        } catch (error) {
          console.error(`Retry ${retryCount + 1} failed:`, error);
          retryCount++;
          if (retryCount >= maxRetries) throw error;
        }
      }

      if (retryCount >= maxRetries) {
        throw new Error("콘텐츠 분석에 실패했습니다. 다시 시도해주세요.");
      }

      // setAutoDisplayContentGeneratorMeal([
      //   {
      //     "date": "2025-07-03",
      //     "day_name": "기말고사",
      //     "day_menu": [],
      //   },
      //   {
      //     "date": "2025-07-04",
      //     "day_name": "기말고사",
      //     "day_menu": [],
      //   },
      //   {
      //     "date": "2025-07-05",
      //     "day_name": "기말고사",
      //     "day_menu": [],
      //   },
      //   {
      //     "date": "2025-07-06",
      //     "day_name": "",
      //     "day_menu": [
      //       "칼슘강화기장밥",
      //       "감자탕",
      //       "미트볼사과소스조림",
      //       "청포묵김가루무침",
      //       "섞박지",
      //       "미니슈크림파이",
      //     ],
      //   },
      //   {
      //     "date": "2025-07-07",
      //     "day_name": "학생식단반영",
      //     "day_menu": [
      //       "마늘계란볶음밥-미니",
      //       "마라탕",
      //       "유린기",
      //       "배추김치",
      //       "단무지",
      //       "리치에이드",
      //     ],
      //   },
      //   {
      //     "date": "2025-07-10",
      //     "day_name": "",
      //     "day_menu": [
      //       "쌀밥",
      //       "들깨미역국",
      //       "직화제육불고기",
      //       "스크램블에그",
      //       "케찹",
      //       "깍두기",
      //       "망고주스",
      //     ],
      //   },
      //   {
      //     "date": "2025-07-11",
      //     "day_name": "초복",
      //     "day_menu": [
      //       "칼슘찹쌀밥",
      //       "장각삼계탕",
      //       "매콤어묵볶음",
      //       "스틱채소",
      //       "쌈장",
      //       "배추겉절이",
      //       "수박",
      //     ],
      //   },
      //   {
      //     "date": "2025-07-12",
      //     "day_name": "",
      //     "day_menu": [
      //       "김가루밥-미니",
      //       "냉면",
      //       "고기만두",
      //       "양념장",
      //       "열무김치",
      //       "방울토마토",
      //     ],
      //   },
      //   {
      //     "date": "2025-07-13",
      //     "day_name": "",
      //     "day_menu": [
      //       "병아리콩밥",
      //       "참치김치찌개",
      //       "함박스테이크",
      //       "데미소스",
      //       "취나물볶음",
      //       "콘샐러드",
      //       "총각김치",
      //     ],
      //   },
      //   {
      //     "date": "2025-07-14",
      //     "day_name": "학생식단반영",
      //     "day_menu": [
      //       "숯불순살치밥",
      //       "가쓰오장국",
      //       "연잎핫도그",
      //       "케찹",
      //       "백김치",
      //       "애플자몽푸딩",
      //     ],
      //   },
      //   {
      //     "date": "2025-07-17",
      //     "day_name": "학생식단반영",
      //     "day_menu": [
      //       "현미밥",
      //       "한우사골순대국",
      //       "궁중떡볶이",
      //       "아삭이고추된장무침",
      //       "섞박지",
      //       "아이스홍시",
      //     ],
      //   },
      //   {
      //     "date": "2025-07-18",
      //     "day_name": "방학식",
      //     "day_menu": [],
      //   },
      //   {
      //     "date": "2025-07-21",
      //     "day_name": "",
      //     "day_menu": [
      //       "칼슘강화기장밥",
      //       "맑은콩나물국",
      //       "분모자로제찜닭",
      //       "베이컨감자채볶음",
      //       "배추김치",
      //       "마시는요거트(사과)",
      //     ],
      //   },
      //   {
      //     "date": "2025-07-22",
      //     "day_name": "",
      //     "day_menu": [
      //       "칼슘강화기장밥",
      //       "맑은콩나물국",
      //       "분모자로제찜닭",
      //       "베이컨감자채볶음",
      //       "배추김치",
      //       "마시는요거트(사과)",
      //     ],
      //   },
      //   {
      //     "date": "2025-07-23",
      //     "day_name": "학생식단반영",
      //     "day_menu": [
      //       "마늘계란볶음밥-미니",
      //       "마라탕",
      //       "유린기",
      //       "배추김치",
      //       "단무지",
      //       "리치에이드",
      //     ],
      //   },
      //   {
      //     "date": "2025-07-24",
      //     "day_name": "",
      //     "day_menu": [
      //       "쌀밥",
      //       "들깨미역국",
      //       "직화제육불고기",
      //       "스크램블에그",
      //       "케찹",
      //       "깍두기",
      //       "망고주스",
      //     ],
      //   },
      //   {
      //     "date": "2025-07-25",
      //     "day_name": "",
      //     "day_menu": [
      //       "칼슘찹쌀밥",
      //       "장각삼계탕",
      //       "매콤어묵볶음",
      //       "스틱채소",
      //       "쌈장",
      //       "배추겉절이",
      //       "수박"
      //     ]
      //   },
      //   {
      //     "date": "2025-07-28",
      //     "day_name": "",
      //     "day_menu": [
      //       "쌀밥",
      //       "맑은순두부국",
      //       "콩나물주꾸미불고기",
      //       "날치알마요소스",
      //       "깻잎",
      //       "애호박느타리볶음",
      //       "배추김치",
      //     ],
      //   },
      //   {
      //     "date": "2025-07-29",
      //     "day_name": "",
      //     "day_menu": [
      //       "칼슘강화기장밥",
      //       "맑은콩나물국",
      //       "분모자로제찜닭",
      //       "베이컨감자채볶음",
      //       "배추김치",
      //       "마시는요거트(사과)"
      //     ]
      //   },
      //   {
      //     "date": "2025-07-30",
      //     "day_name": "학생식단반영",
      //     "day_menu": [
      //       "마늘계란볶음밥-미니",
      //       "마라탕",
      //       "유린기",
      //       "배추김치",
      //       "단무지",
      //       "리치에이드"
      //     ]
      //   },
      //   {
      //     "date": "2025-07-31",
      //     "day_name": "",
      //     "day_menu": [
      //       "쌀밥",
      //       "들깨미역국",
      //       "직화제육불고기",
      //       "스크램블에그",
      //       "케찹",
      //       "깍두기",
      //       "망고주스"
      //     ]
      //   },
      //   {
      //     "date": "2025-08-01",
      //     "day_name": "",
      //     "day_menu": [
      //       "칼슘찹쌀밥",
      //       "장각삼계탕",
      //       "매콤어묵볶음",
      //       "스틱채소",
      //       "쌈장",
      //       "배추겉절이",
      //       "수박",
      //     ],
      //   },
      //   {
      //     "date": "2025-08-14",
      //     "day_name": "학생식단반영",
      //     "day_menu": [
      //       "칼슘강화기장밥",
      //       "맑은콩나물국",
      //       "분모자로제찜닭",
      //       "베이컨감자채볶음",
      //       "배추김치",
      //       "마시는요거트(사과)",
      //     ],
      //   },
      //   {
      //     "date": "2025-08-15",
      //     "day_name": "광복절",
      //     "day_menu": [],
      //   },
      //   {
      //     "date": "2025-08-16",
      //     "day_name": "학생식단반영",
      //     "day_menu": [
      //       "추가밥",
      //       "자장면",
      //       "순살파닭",
      //       "깍두기",
      //       "단무지",
      //       "감귤한라봉쥬스",
      //     ],
      //   },
      //   {
      //     "date": "2025-08-17",
      //     "day_name": "",
      //     "day_menu": [
      //       "쌀밥",
      //       "맑은순두부국",
      //       "콩나물주꾸미불고기",
      //       "날치알마요소스",
      //       "깻잎",
      //       "애호박느타리볶음",
      //       "배추김치",
      //     ],
      //   },
      //   {
      //     "date": "2025-08-18",
      //     "day_name": "",
      //     "day_menu": [
      //       "쇠고기콩나물밥",
      //       "양념장",
      //       "두부된장국",
      //       "뿌링소떡소떡",
      //       "배추김치",
      //       "유기농식혜",
      //     ],
      //   },
      //   {
      //     "date": "2025-08-21",
      //     "day_name": "",
      //     "day_menu": [
      //       "흑미밥",
      //       "송정식부대찌개",
      //       "삼치구이",
      //       "강정소스",
      //       "볼어묵야채조림",
      //       "총각김치",
      //       "뽕따아이스크림",
      //     ],
      //   },
      //   {
      //     "date": "2025-08-22",
      //     "day_name": "",
      //     "day_menu": [
      //       "찹쌀밥",
      //       "오이미역냉국",
      //       "돼지갈비찜",
      //       "진미채볶음",
      //       "배추김치",
      //       "가나슈타르트(수제)",
      //     ],
      //   },
      //   {
      //     "date": "2025-08-23",
      //     "day_name": "학생식단반영",
      //     "day_menu": [
      //       "떠먹는유부초밥",
      //       "순대",
      //       "국물떡볶이",
      //       "열무김치",
      //       "스틱단무지",
      //       "골드파인애플",
      //     ],
      //   },
      //   {
      //     "date": "2025-08-24",
      //     "day_name": "",
      //     "day_menu": [
      //       "찹쌀밥",
      //       "호박된장찌개",
      //       "언양식불고기",
      //       "레몬파채무침",
      //       "버섯잡채",
      //       "배추겉절이",
      //       "조각멜론",
      //     ],
      //   },
      //   {
      //     "date": "2025-08-25",
      //     "day_name": "",
      //     "day_menu": [
      //       "새우굴소스볶음밥",
      //       "팽이버섯계란국",
      //       "하노이갈비살분짜",
      //       "열대과일샐러드",
      //       "깍두기",
      //     ],
      //   },
      //   {
      //     "date": "2025-08-28",
      //     "day_name": "",
      //     "day_menu": [
      //       "쌀밥",
      //       "모듬어묵국",
      //       "오리고추장불고기",
      //       "숙주나물무침",
      //       "배추김치",
      //       "아오리사과(조각)",
      //     ],
      //   },
      //   {
      //     "date": "2025-08-29",
      //     "day_name": "",
      //     "day_menu": [
      //       "쌀밥",
      //       "감자고추장찌개",
      //       "돼지고기수육",
      //       "상추쌈",
      //       "명엽채볶음",
      //       "보쌈김치",
      //       "자두",
      //     ],
      //   },
      //   {
      //     "date": "2025-08-30",
      //     "day_name": "그린급식의 날",
      //     "day_menu": [
      //       "김가루밥 - 미니",
      //       "김치말이국수",
      //       "비빔만두",
      //       "배추겉절이",
      //       "유산균음료",
      //     ],
      //   },
      //   {
      //     "date": "2025-08-31",
      //     "day_name": "학생식단반영",
      //     "day_menu": [
      //       "곤드레밥",
      //       "양념장",
      //       "감자옹심이국",
      //       "치즈닭갈비",
      //       "레몬무쌈",
      //       "나박김치",
      //       "감자빵",
      //     ],
      //   },
      // ]);

      setToolSteps(3);
      setCompletedSteps((prev) => [...prev, 3]);
      setShowTemplateSelection(true); // 바로 콘텐츠 시안을 보여주기 위해 상태 변경
    } catch (error) {
      console.error("콘텐츠 분석 중 오류 발생:", error);
      setShowPopupError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleChangeStatus = ({ meta, file, remove }, status) => {
    const maxSize = 20 * 1024 * 1024; // 20MB
    if (file.size > maxSize && status !== "removed") {
      setShowPopupFileSize(true);
      remove();
      return;
    }

    if (status === "done" || status === "preparing" || status === "uploading") {
      setUploadedFiles((prev) => {
        if (!prev.find((f) => f.name === file.name)) {
          setFileNames((prev) => [...prev, file.name]);
          return [...prev, file];
        }
        return prev;
      });
    } else if (status === "removed") {
      setUploadedFiles((prev) => prev.filter((f) => f.name !== file.name));
      setFileNames((prev) => prev.filter((name) => name !== file.name));
    }

    const size = file.size;
    const sizeStr =
      size > 1024 * 1024
        ? `${(size / (1024 * 1024)).toFixed(1)}MB`
        : `${(size / 1024).toFixed(1)}KB`;

    setTimeout(() => {
      const containers = document.querySelectorAll(".dzu-previewContainer");
      containers.forEach((container) => {
        if (!container.dataset.filename) {
          container.dataset.filename = file.name;
          container.dataset.size = sizeStr;

          if (file.type.startsWith("image/")) {
            if (!container.querySelector(".dzu-previewFileName")) {
              const nameSpan = document.createElement("span");
              nameSpan.className = "dzu-previewFileName";
              nameSpan.textContent = `${file.name}, ${sizeStr}`;

              if (container.firstChild) {
                container.insertBefore(nameSpan, container.firstChild);
              } else {
                container.appendChild(nameSpan);
              }
            }
          }
        }
      });
    }, 0);
  };

  const handleConfirmCredit = async () => {
    setShowCreatePersonaPopup(false);
  };

  const handleDesignConceptSelect = (conceptId) => {
    // 4단계가 완료된 후에는 디자인 선택을 변경할 수 없음
    if (completedSteps.includes(4)) {
      return;
    }
    
    setSelectedDesignConcepts((prev) => {
      if (prev.includes(conceptId)) {
        return [];
      } else {
        return [conceptId];
      }
    });
  };

  const handleDisplayConversion = async () => {
    setIsLoadingTemplate(true);

    setTimeout(() => {
      setShowTemplateSelection(true);
      setIsLoadingTemplate(false);
    }, 5000);
  };

  const handleTemplatePreview = (concept) => {
    setTemplateToPreview({
      ...concept,
      category: concept.id,
    });
    console.log(
      "미리보기 시점의 selectedPurposes.customerList:",
      selectedPurposes.customerList
    );
    setContentsPurpose(selectedPurposes.customerList); // 미리보기 시점에서 contentsPurpose 설정
    setShowTemplatePreview(true);
  };

  const handleCloseTemplatePreview = () => {
    setShowTemplatePreview(false);
    setTemplateToPreview(null);
  };

  const handleConfirmContent = async () => {
    // 4단계가 이미 완료된 경우 API 호출 없이 바로 4단계로 이동
    if (completedSteps.includes(4)) {
      setActiveTab(4);
      return;
    }

    handleNextStep(3);
    setToolSteps(4);

    try {
      const createViewId = await createEduViewOnServer(isLoggedIn);

      // const selectedTemplateData = templateData.find(
      //   (template) => template.id === selectedTemplate
      // );
      // setSelectedTemplateData(selectedTemplateData);

      // const category = selectedTemplateData?.category;
      // const conceptIndex = selectedDesignConcepts.findIndex(
      //   (c) => c === category
      // );

      let finalMarkdown = null;
      let finalTitle = null;
      let finalJson = null;

      // if (category === "모던 게시판형") {
      //   finalJson = autoDisplayContentGeneratorJson;
      //   // } else if (conceptIndex !== -1) {
      //   //   finalMarkdown = autoDisplayContentGeneratorMarkdown[conceptIndex];
      //   //   finalTitle = autoDisplayContentGeneratorTitle[conceptIndex];
      //   // }
      // } else {
      finalMarkdown = autoDisplayContentGeneratorMarkdown;
      finalTitle = autoDisplayContentGeneratorTitle[0];
      // }

      // 데이터를 조합하여 contentData 객체 생성
      const now = new Date();
      const contentData = {
        contentsType: "meal",
        viewDevice: {
          _id: selectedDevice?._id || "",
          deviceTitle: selectedDevice?.deviceTitle || "",
          deviceDPI: selectedDevice?.deviceSpec?.deviceDPI || "",
          deviceInch: selectedDevice?.deviceSpec?.deviceInch || "",
          deviceCm: selectedDevice?.deviceSpec?.deviceCm || "",
          deviceWidth: selectedDevice?.deviceSpec?.deviceWidth || "",
          deviceHeight: selectedDevice?.deviceSpec?.deviceHeight || "",
        },
        uploadFileData: uploadedFiles.map((file, index) => ({
          id: "file_" + timeStamp + "_" + (index + 1),
          name: file.name,
        })),
        textData: businessDescription,
        dataAnalysis: {
          title: autoDisplayFileAnalysis?.title || "",
          source: autoDisplayFileAnalysis?.source || "",
          message: autoDisplayFileAnalysis?.message || "",
          detail: autoDisplayFileAnalysis?.detail || "",
        },
        designConcept: selectedDesignConcepts[0],
        contentsTarget: contentTarget,
        contentGeneratorMeal: autoDisplayContentGeneratorMeal,
        nutritionMessage: nutritionMessage,
        createDate: now.toLocaleString("ko-KR", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
        }),
        createTimestamp: now.getTime(),
      };
      if (customerId !== "") {
        contentData.customer = customerId;
      }
      setContentsPurpose(selectedPurposes.customerList);
      console.log(
        "selectedPurposes.customerList",
        selectedPurposes.customerList
      );
      await updateEduViewOnServer(createViewId, contentData);

      // 4단계 완료 처리
      setCompletedSteps(prev => [...prev, 4]);

      // setAutoDisplaySelectedContent(createViewId);
      // navigate("/DashBoard");
    } catch (error) {
      console.error("콘텐츠 확인 또는 업데이트 실패:", error);
    }
  };

  useEffect(() => {
    // 새로고침 감지 함수
    const detectRefresh = () => {
      // 현재 URL 확인
      const currentUrl = window.location.href;
      if (currentUrl.toLowerCase().includes("createeducationmeal")) {
        // 세션 스토리지에서 마지막 URL 가져오기
        const lastUrl = sessionStorage.getItem("lastUrl");

        // 마지막 URL이 현재 URL과 같으면 새로고침
        if (lastUrl && lastUrl === currentUrl) {
          // if (customerId !== "") {
          //   navigate("/EduboardManage");
          //   } else {
              navigate("/EducationDashBoard");
            // }
          return true;
        }

        // 현재 URL 저장
        sessionStorage.setItem("lastUrl", currentUrl);
      }

      return false;
    };

    // F5 키 또는 Ctrl+R 감지
    const handleKeyDown = (event) => {
      if (
        (event.key === "r" && (event.metaKey || event.ctrlKey)) ||
        event.key === "F5"
      ) {
        // F5 키 코드
        event.preventDefault();

        // if (customerId !== "") {
        //   navigate("/EduboardManage");
        // } else {
          navigate("/EducationDashBoard");
        // }
      }
    };

    // 함수 실행
    detectRefresh();

    // 이벤트 리스너 등록
    window.addEventListener("keydown", handleKeyDown);

    // 컴포넌트 언마운트 시 이벤트 리스너 제거
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [navigate]);

  const handleGoBack = async () => {
    try {
      // 현재 저장된 데이터를 가져온다
      let currentData;
      const currentViewId = customerId;

      // currentData = await getViewDetailOnServer(currentViewId, isLoggedIn);

      // console.log("currentData", currentData);

      if (
        currentData &&
        currentData.activateCode &&
        Array.isArray(currentData.activateCode)
      ) {
        // activateCode 배열에서 state와 activeState가 1인 항목들의 updateState를 1로 변경
        const updatedActivateCode = currentData.activateCode.map((item) => {
          if (item.state === 1 && item.activeState === 1) {
            return {
              ...item,
              updateState: 1,
            };
          }
          return item;
        });

        // 기존 데이터 유지하면서 activateCode만 업데이트
        const updateData = {
          ...currentData,
          activateCode: updatedActivateCode,
        };

        // 데이터 타입에 따라 적절한 업데이트 함수 호출
        await updateEduViewOnServer(currentViewId, updateData);

        // console.log("activateCode 업데이트 완료:", updatedActivateCode);
      }

      // 완료 후 페이지 이동
      navigate("/EducationDashBoard");
    } catch (error) {
      console.error("돌아가기 처리 중 오류 발생:", error);
      // 오류가 발생해도 페이지는 이동
      navigate("/EducationDashBoard");
    }
  };

  return (
    <>
      <DropzoneStyles />
      <ContentsWrap>
        {/* <OrganismIncNavigation /> */}
        {/* <MoleculeHeader /> */}
        <MoleculeCreateDisplayHeader
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          completedSteps={completedSteps}
          isLoading={isLoading}
          isLoadingReport={isLoadingReport}
          onPreview={handleTemplatePreview}
          onSubmitConcept={handleSubmitConcept}
          onSubmitReport={handleSubmitPurpose}
          hasContentDraft={showTemplateSelection}
          onConfirmContent={handleConfirmContent}
          isLoadingTemplate={isLoadingTemplate}
          // 1단계에서 파일 업로드가 있는지 확인
          canProceedFromStep1={
            activeTab === 1 ? fileNames && fileNames.length > 0 : true
          }
          // 2단계에서 모든 필수 항목이 선택되었는지 확인
          canProceedFromStep2={
            activeTab === 2
              ? // selectedPurposes.customerList &&
                // selectedTargetAudience
                true
              : true
          }
          canProceedFromStep3={
            activeTab === 3 && showTemplateSelection
              ? selectedDesignConcepts.length > 0
              : true
          }
        />

        <MainContent Wide1030>
          <DesignAnalysisWrap>
            {activeTab === 1 && (
              <TabContent5>
                <>
                  <div className="content">
                    <TabContent5Item required>
                      <div style={{ height: "20px" }}></div> {/* 간격용 div */}
                      <H3
                        color="gray800"
                        style={{ textAlign: "left", marginBottom: "12px" }}
                      >
                        AI 급식 식단 생성을 위한 자료를 업로드해주세요{" "}
                      </H3>
                      <InfoBox>
                        <InfoContent>
                          <Body2
                            color="black"
                            style={{
                              fontWeight: "600",
                              textAlign: "left",
                              fontSize: "20px",
                            }}
                          >
                            {selectedDevice?.deviceTitle}
                          </Body2>
                          <DeviceInfoBox>
                            <Body3 color="gray600">
                              {selectedDevice?.deviceSpec.deviceDPI}
                            </Body3>
                            <Body3 color="gray600">
                              {selectedDevice?.deviceSpec.deviceInch}
                            </Body3>
                            <Body3 color="gray600">
                              {selectedDevice?.deviceSpec.deviceWidthMM}x
                              {selectedDevice?.deviceSpec.deviceHeightMM} (mm)
                            </Body3>
                          </DeviceInfoBox>
                        </InfoContent>
                      </InfoBox>
                    </TabContent5Item>
                  </div>

                  <div className="content">
                    <TabContent5Item required>
                      <InterviewModeSelection style={{ marginBottom: "-5px" }}>
                        {/* <Button
                          Medium
                          Outline
                          style={{
                            backgroundColor:
                              interviewModeType === "article"
                                ? "#F7F8FA"
                                : "transparent",
                            borderColor:
                              interviewModeType === "article"
                                ? "#E0E4EB"
                                : "#E0E4EB",
                          }}
                          onClick={() => {
                            if (toolSteps >= 1 || isLoadingPreset) return;
                            setInterviewModeType("article");
                          }}
                          disabled={toolSteps >= 1 || isLoadingPreset}
                        >
                          <InputText color="gray700">게시글로 시작</InputText>
                        </Button> */}
                      </InterviewModeSelection>

                      {interviewModeType === "conceptBoard" && (
                        <div className="content" style={{ marginTop: "5px" }}>
                          <MoleculeFileUpload
                            fileNames={fileNames ?? []}
                            handleChangeStatus={handleChangeStatus}
                            toolSteps={toolSteps}
                            maxFiles={1}
                            type="meal"
                          />
                        </div>
                      )}
                    </TabContent5Item>

                    {/* {interviewModeType === "article" && (
                      <div
                        style={{
                          width: "100%",
                          maxWidth: "820px",
                          margin: "0 auto",
                          display: "flex",
                          flexDirection: "column",
                          gap: "16px",
                          marginTop: "20px",
                        }}
                      >
                        {messages.map((msg) => (
                          <MoleculeMessageCard
                            key={msg.id}
                            id={msg.id}
                            translatedText={msg.translate}
                            originalText={msg.original}
                            isSelected={msg.id === selectedMessage?.id}
                            onSelect={() => {
                              if (toolSteps >= 1) return;
                              setSelectedMessage(msg);
                            }}
                            disabled={toolSteps >= 1}
                          />
                        ))}
                      </div>
                    )} */}
                  </div>

                  {/* <Button
                        Other
                        Primary
                        Fill
                        Round
                        onClick={handleSubmitConcept}
                        
                      >
                        다음
                      </Button>
                   */}
                </>
              </TabContent5>
            )}

            {activeTab === 2 && completedSteps.includes(1) && (
              <TabContent5>
                {isLoading ? (
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      minHeight: "200px",
                      alignItems: "center",
                    }}
                  >
                    <AtomPersonaLoader message="콘텐츠 핵심 내용을 AI로 분석하고 있어요" />
                    <div style={{ height: "520px" }}></div> {/* 간격용 div */}
                  </div>
                ) : (
                  <>
                    <div className="content">
                      <TabContent5Item required>
                        <div style={{ height: "20px" }}></div>{" "}
                        {/* 간격용 div */}
                        <H3
                          color="gray800"
                          style={{ textAlign: "left", marginBottom: "-12px" }}
                        >
                          콘텐츠 주요 내용 및 디스플레이 정보​{" "}
                        </H3>
                        <ContentAnalysisSection>
                          <MoleculeAnalysisCard
                            values={{
                              deviceInfo: `${selectedDevice?.deviceTitle} (${selectedDevice?.deviceSpec.deviceInch} / ${selectedDevice?.deviceSpec.deviceWidth}x${selectedDevice?.deviceSpec.deviceHeight} (mm))`,
                              analysisData: autoDisplayFileAnalysis,
                            }}
                          />

                          <ContentOptionsSection>
                            <H3
                              color="gray800"
                              style={{ textAlign: "left", marginTop: "0px" }}
                            >
                              아래 항목을 선택해주세요{" "}
                            </H3>

                            <TabContent5Item>
                              <div className="title" style={{}}>
                                <Body3 color="gray700">추가 영양 정보</Body3>
                              </div>
                              <FormBox
                                Large
                                style={{ marginTop: "0px", width: "100%" }}
                              >
                                <CustomTextarea
                                  Edit
                                  rows={4}
                                  placeholder="학생들에게 전하고 싶은 오늘의 영양 메시지를 입력하세요."
                                  value={nutritionMessage}
                                  onChange={(e) =>
                                    setNutritionMessage(e.target.value)
                                  }
                                  status="valid"
                                  disabled={completedSteps.includes(2)}
                                  maxLength={200}
                                />
                                <div style={{ 
                                  display: 'flex', 
                                  justifyContent: 'space-between', 
                                  alignItems: 'center',
                                  marginTop: '8px'
                                }}>
                                  <span style={{ 
                                    color: '#464C53', 
                                    fontSize: '12px',
                                    fontWeight: '400',
                                    lineHeight: '18px' 
                                  }}>
                                    200자 이내로 작성해주세요.
                                  </span>
                                  <span style={{ 
                                    color: nutritionMessage.length > 200 ? '#FF3B30' : '#464C53',
                                    fontSize: '12px',
                                    fontWeight: '400',
                                    lineHeight: '18px' 
                                  }}>
                                    {nutritionMessage.length}/200
                                  </span>
                                </div>
                              </FormBox>
                            </TabContent5Item>
                          </ContentOptionsSection>
                        </ContentAnalysisSection>
                      </TabContent5Item>
                    </div>

                    {/* <Button
                        Other
                        Primary
                        Fill
                        Round
                        onClick={() => {
                          handleSubmitPurpose();
                        }}
                    
                      >
                        다음
                      </Button>
                */}
                  </>
                )}
              </TabContent5>
            )}

            {activeTab === 3 &&
              (completedSteps.includes(2) || completedSteps.includes(3)) && (
                <TabContent5>
                  {isLoading ? (
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        minHeight: "200px",
                        alignItems: "center",
                      }}
                    >
                      <AtomPersonaLoader
                        message={
                          "AI가 핵심 내용을 추출하여 디스플레이에 적합한 정보로 바꾸고 있어요"
                        }
                      />
                      <div style={{ height: "520px" }}></div> {/* 간격용 div */}
                    </div>
                  ) : (
                    <>
                      <div className="content">
                        <TabContent5Item required>
                          <div style={{ height: "20px" }}></div>{" "}
                          {/* 간격용 div */}
                          <H3
                            color="gray800"
                            style={{ textAlign: "left", marginBottom: "-12px" }}
                          >
                            콘텐츠 주요 내용 및 디스플레이 정보{" "}
                          </H3>
                          <ContentAnalysisSection>
                            <MoleculeAnalysisCard
                              showButton={false}
                              type="template"
                              onButtonClick={() => {
                                setShowPreviewPopup(true);
                                // setSelectedTemplate(template);
                              }}
                              values={{
                                deviceInfo: `${selectedDevice?.deviceTitle} (${selectedDevice?.deviceSpec.deviceInch} / ${selectedDevice?.deviceSpec.deviceWidth}x${selectedDevice?.deviceSpec.deviceHeight} (mm))`,
                                analysisData: autoDisplayFileAnalysis,
                                contentPurpose: selectedPurposes.customerList,
                                designConcept: selectedDesignConcepts,
                              }}
                            />

                            {isLoadingTemplate ? (
                              <div
                                style={{
                                  width: "100%",
                                  display: "flex",
                                  justifyContent: "center",
                                  minHeight: "200px",
                                  alignItems: "center",
                                }}
                              >
                                {/* <AtomPersonaLoader message="콘텐츠 핵심 내용을 AI로 분석하고 있어요" /> */}
                                <AtomPersonaLoader
                                  message={
                                    <>
                                      <span>디자인을 생성 중입니다</span>
                                      <span
                                        style={{
                                          fontSize: "14px",
                                          fontWeight: "400",
                                          color: palette.gray500,
                                        }}
                                      >
                                        {/* {" "}
                                        평균 소요 시간은 컨셉당 약 1분입니다.
                                        준비되면 바로 확인하실 수 있어요{" "} */}
                                      </span>
                                    </>
                                  }
                                />
                              </div>
                            ) : showTemplateSelection ? (
                              <ContentOptionsSection>
                                <TabContent5Item>
                                  <div
                                    className="title"
                                    style={{ marginTop: "0px" }}
                                  >
                                    <H4 color="gray800">콘텐츠 시안</H4>
                                  </div>
                                  <TabContent5Item>
                                    <div className="title" style={{}}>
                                      {/* <Body3 color="gray700">백그라운드 선택</Body3> */}
                                    </div>
                                  </TabContent5Item>

                                  <ConceptSelectorContainer>
                                    {designConceptsData.map((concept) => (
                                      <ConceptCard key={concept.id}>
                                        <CheckboxLabel>
                                          <CheckCircle
                                            type="checkbox"
                                            checked={selectedDesignConcepts.includes(
                                              concept.id
                                            )}
                                            onChange={() =>
                                              handleDesignConceptSelect(
                                                concept.id
                                              )
                                            }
                                            disabled={completedSteps.includes(4)}
                                          />
                                          <H4>{concept.name}</H4>
                                        </CheckboxLabel>
                                        <ImagePreviewContainer>
                                          <img
                                            src={concept.image}
                                            alt={concept.name}
                                            style={{
                                              width: "100%",
                                              height: "100%",
                                              objectFit: "cover",
                                            }}
                                          />
                                          <PreviewButton
                                            onClick={() =>
                                              handleTemplatePreview(concept)
                                            }
                                          >
                                            <svg
                                              width="16"
                                              height="16"
                                              viewBox="0 0 24 24"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path
                                                d="M12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5ZM12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17ZM12 9C10.34 9 9 10.34 9 12C9 13.66 10.34 15 12 15C13.66 15 15 13.66 15 12C15 10.34 13.66 9 12 9Z"
                                                fill="white"
                                              />
                                            </svg>
                                            미리보기
                                          </PreviewButton>
                                        </ImagePreviewContainer>
                                      </ConceptCard>
                                    ))}
                                  </ConceptSelectorContainer>
                                </TabContent5Item>
                              </ContentOptionsSection>
                            ) : (
                              <ContentOptionsSection>
                                <TabContent5Item>
                                  {/* <div className="title">
                                    <Body1 color="gray700">콘텐츠 목적</Body1>
                                  </div>

                                  <SelectBox
                                    onClick={() => {
                                      if (toolSteps >= 1) return;
                                      setIsSelectBoxOpen(!isSelectBoxOpen);
                                    }}
                                    disabled={toolSteps >= 1}
                                    style={{
                                      cursor:
                                        toolSteps >= 1
                                          ? "not-allowed"
                                          : "pointer",
                                    }}
                                  >
                                    <SelectBoxTitle>
                                      <Body2
                                        color={
                                          selectedPurposes.customerList
                                            ? "gray800"
                                            : "gray300"
                                        }
                                      >
                                        {selectedPurposes.customerList ||
                                          "선택해주세요"}
                                      </Body2>
                                      <images.ChevronDown
                                        width="24px"
                                        height="24px"
                                        color={palette.gray500}
                                        style={{
                                          transform:
                                            selectBoxStates.customerList
                                              ? "rotate(180deg)"
                                              : "rotate(0deg)",
                                          transition: "transform 0.3s ease",
                                        }}
                                      />
                                    </SelectBoxTitle>

                                    {selectBoxStates.customerList && (
                                      <SelectBoxList
                                        dropUp={dropUpStates.customerList}
                                        style={{ zIndex: "1000" }}
                                      >
                                        {contentTypeOptions.map((option) => (
                                          <SelectBoxItem
                                            key={option}
                                            onClick={() =>
                                              handleContentTypeSelect(option)
                                            }
                                          >
                                            <Body2 color="gray700" align="left">
                                              {option}
                                            </Body2>
                                          </SelectBoxItem>
                                        ))}
                                      </SelectBoxList>
                                    )}
                                  </SelectBox> */}

                                  {/* <div
                                    className="title"
                                    style={{ marginTop: "24px" }}
                                  >
                                    <Body1 color="gray700">
                                      콘텐츠 방향성{" "}
                                    </Body1>
                                  </div> */}
                                  {/* <FormBox Large style={{ textAlign: "left" }}>
                                    <CustomTextarea
                                      Edit
                                      rows={1}
                                      placeholder="작성해주세요"
                                      value={contentTarget}
                                      onChange={(e) =>
                                        setContentTarget(e.target.value)
                                      }
                                      status="valid"
                                    />
                                    {
                                      autoDisplayContentGenerator?.content_direction
                                    }
                                  </FormBox> */}

                                  <div
                                    className="title"
                                    style={{ marginTop: "24px" }}
                                  >
                                    <Body1 color="gray700">콘텐츠 내용 </Body1>
                                  </div>

                                  {/* 선택된 디자인 컨셉별로 콘텐츠 박스 생성 */}
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "16px",
                                    }}
                                  >
                                    <ContentConceptBox>
                                      <ContentConceptHeader>
                                        <ConceptTitle></ConceptTitle>
                                        <RegenerateButton
                                          onClick={() =>
                                            handleSubmitPurpose(true)
                                          }
                                          // disabled={regeneratingConcepts.has(
                                          //   concept
                                          // )}
                                        >
                                          <svg
                                            width="13"
                                            height="13"
                                            viewBox="0 0 13 13"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              d="M6.93569 1.10238C6.73825 3.72605 4.44413 4.92239 3.01117 5.27398C2.81081 5.32314 2.66211 5.49758 2.66211 5.70389C2.66211 5.93696 2.85208 6.12328 3.08346 6.15135C5.21146 6.40957 6.69369 8.57558 6.91937 9.99338C6.95039 10.1882 7.10929 10.3482 7.30661 10.3482C7.50393 10.3482 7.66218 10.1869 7.67846 9.99024C7.88338 7.51524 10.2016 6.46546 11.655 6.18303C11.8603 6.14314 12.0161 5.96846 12.0161 5.75933C12.0161 5.53126 11.8294 5.34842 11.6022 5.32934C8.87385 5.10025 7.89142 2.61312 7.69599 1.07933C7.67136 0.886049 7.51151 0.734375 7.31667 0.734375C7.1138 0.734375 6.95091 0.900081 6.93569 1.10238Z"
                                              fill="#226FFF"
                                            />
                                            <path
                                              d="M1.88689 8.77442C1.80044 9.92325 0.795916 10.4471 0.168467 10.601C0.0807353 10.6226 0.015625 10.6989 0.015625 10.7893C0.015625 10.8913 0.098793 10.9729 0.200148 10.9849C1.13514 11.0952 1.78541 12.0247 1.88075 12.6673C1.89343 12.7528 1.96291 12.8229 2.04931 12.8229C2.13571 12.8229 2.205 12.7522 2.21213 12.6661C2.30186 11.5824 3.31694 11.1227 3.95333 10.9991C4.04322 10.9816 4.11144 10.9051 4.11144 10.8136C4.11144 10.7137 4.02971 10.6336 3.9302 10.6253C2.73555 10.525 2.30538 9.43593 2.21981 8.76433C2.20902 8.67969 2.13903 8.61328 2.05371 8.61328C1.96488 8.61328 1.89356 8.68584 1.88689 8.77442Z"
                                              fill="#226FFF"
                                            />
                                          </svg>
                                          <span>다시 생성</span>
                                        </RegenerateButton>
                                      </ContentConceptHeader>
                                      <ContentConceptBody>
                                        {/* {regeneratingConcepts.has(
                                              concept
                                            ) ? (
                                              <div
                                                style={{
                                                  width: "100%",
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  minHeight: "200px",
                                                  alignItems: "center",
                                                }}
                                              >
                                                <AtomPersonaLoader
                                                  message={`${concept} 콘텐츠를 재생성하고 있습니다`}
                                                />
                                              </div>
                                            ) : ( */}
                                        <div
                                          className="markdown-body core-value-section"
                                          style={{
                                            color: palette.gray800,
                                            textAlign: "left",
                                            "& h1, & h2, & h3, & h4, & h5, & h6":
                                              {
                                                marginBottom: "0px",
                                                marginTop: "0px",
                                              },
                                            "& h1 + p, & h2 + p, & h3 + p, & h4 + p, & h5 + p, & h6 + p":
                                              {
                                                marginTop: "12px",
                                              },
                                          }}
                                        >
                                          <h1
                                            style={{
                                              fontSize: "40px",
                                              fontWeight: "700",
                                              marginBottom: "20px",
                                            }}
                                          >
                                            {autoDisplayContentGeneratorTitle.length >
                                              0 &&
                                              autoDisplayContentGeneratorTitle.map(
                                                (title, titleIndex) => (
                                                  <div key={titleIndex}>
                                                    {title}
                                                  </div>
                                                )
                                              )}
                                          </h1>
                                          <Markdown>
                                            {
                                              autoDisplayContentGeneratorMarkdown[0]
                                            }
                                          </Markdown>
                                          <Markdown>
                                            {
                                              autoDisplayContentGeneratorMarkdown[1]
                                            }
                                          </Markdown>
                                        </div>
                                        {/* )} */}
                                      </ContentConceptBody>
                                    </ContentConceptBox>
                                  </div>
                                </TabContent5Item>
                              </ContentOptionsSection>
                            )}
                          </ContentAnalysisSection>
                        </TabContent5Item>
                      </div>

                      {/* <ButtonContainer style={{ marginTop: "0px" }}>
                        {!showTemplateSelection && !isLoadingTemplate && (
                          <Button
                            Primary
                            Edit
                            Large
                            onClick={() => {
                              handleSubmitPurpose();
                            }}
                          >
                            내용 재생성
                          </Button>
                        )}
                                              
                      <Button
                        Primary
                        Large
                        Fill
                        onClick={handleDisplayConversion}
                      >
                        디스플레이로 변환
                      </Button>
                      </ButtonContainer> */}
                    </>
                  )}
                </TabContent5>
              )}

            {activeTab === 4 &&
              (completedSteps.includes(3) || completedSteps.includes(4)) && (
                <TabContent5>
                  {isLoading ? (
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        minHeight: "200px",
                        alignItems: "center",
                      }}
                    >
                      <AtomPersonaLoader message="콘텐츠 핵심 내용을 AI로 분석하고 있어요" />
                    </div>
                  ) : (
                    <>
                      <div className="content">
                        <TabContent5Item required>
                          <H3
                            color="gray800"
                            style={{ textAlign: "left", marginBottom: "-20px" }}
                          >
                            확정된 콘텐츠를 화면에 적용해보세요{" "}
                          </H3>
                          <DashedLine />
                          <CompletionContainer>
                            <CompletionIcon>
                              <CheckIcon>
                                <svg
                                  width="28"
                                  height="26"
                                  viewBox="0 0 28 26"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M26.7408 1.07458C27.9568 1.9055 28.269 3.56483 27.438 4.78081L13.7714 24.7808C13.3237 25.4359 12.6076 25.8576 11.8176 25.9314C11.0277 26.0052 10.2458 25.7234 9.68463 25.1625L1.34609 16.8292C0.304367 15.7881 0.30384 14.0997 1.34491 13.0579C2.38599 12.0162 4.07443 12.0157 5.11615 13.0568L11.1813 19.1181L23.0346 1.77179C23.8655 0.555813 25.5249 0.243661 26.7408 1.07458Z"
                                    fill="white"
                                  />
                                </svg>
                              </CheckIcon>
                            </CompletionIcon>

                            <CompletionMessage>
                              <H3
                                color="gray800"
                                style={{
                                  marginBottom: "8px",
                                  marginTop: "16px",
                                }}
                              >
                                콘텐츠 등록이 완료되었습니다
                              </H3>
                            </CompletionMessage>
                          </CompletionContainer>

                          <ContentAnalysisSection>
                            <MoleculeAnalysisCard
                              showButton={false}
                              type="template"
                              onButtonClick={() => {
                                setShowPreviewPopup(true);
                                // setSelectedTemplate(template);
                              }}
                              values={{
                                deviceInfo: `${selectedDevice?.deviceTitle} (${selectedDevice?.deviceSpec.deviceInch} / ${selectedDevice?.deviceSpec.deviceWidth}x${selectedDevice?.deviceSpec.deviceHeight} (mm))`,
                                analysisData: autoDisplayFileAnalysis,
                                contentPurpose: selectedPurposes.customerList,
                                // designConcept: (
                                //   templateData.find(template =>s
                                //     selectedDesignConcepts.includes(template.category)
                                //   )?.category || "기본 심플형"
                                // ),
                                designConcept:
                                  selectedDesignConcepts || "concept1",
                              }}
                            />
                          </ContentAnalysisSection>
                          <DashedLine />
                        </TabContent5Item>
                      </div>

                      <ButtonContainer>
                        {/* <Button
                          Primary
                          Edit
                          Large
                          onClick={() => {
                            navigate("/DashBoard");
                          }}
                        >
                          나중에 사용하기
                        </Button> */}
                        <Button
                          Primary
                          Large
                          Fill
                          style={{
                            width: "120px",
                            height: "40px",
                            fontSize: "16px",
                          }}
                          onClick={handleGoBack}
                        >
                          돌아가기
                        </Button>
                        {/* <Button Primary Large Fill onClick={handleDisplayView}>
                          콘텐츠 활성화 하기
                        </Button> */}
                      </ButtonContainer>
                    </>
                  )}
                </TabContent5>
              )}
          </DesignAnalysisWrap>
        </MainContent>
      </ContentsWrap>

      {showTemplatePreview && (
        <OrganismDisplayViewEduMealPreview
          template={templateToPreview}
          onClose={handleCloseTemplatePreview}
          title={autoDisplayFileAnalysis?.title}
          displayWidth={selectedDevice?.deviceSpec?.deviceWidth || "1080"}
          displayHeight={selectedDevice?.deviceSpec?.deviceHeight || "1920"}
          mealData={autoDisplayContentGeneratorMeal}
          noticeText={nutritionMessage}
        />
      )}

      {showPopupError && (
        <PopupWrap
          Warning
          title="다시 입력해 주세요."
          message="현재 입력하신 정보는 목적을 생성할 수 없습니다."
          buttonType="Outline"
          confirmText="확인"
          isModal={false}
          onConfirm={() => window.location.reload()}
        />
      )}

      {showPopupFileSize && (
        <PopupWrap
          Warning
          title="파일 크기 초과"
          message="파일 크기는 20MB를 초과할 수 없습니다."
          buttonType="Outline"
          confirmText="확인"
          isModal={false}
          onConfirm={() => setShowPopupFileSize(false)}
        />
      )}

      {showPopupSave && (
        <PopupWrap
          Check
          title="리포트가 저장되었습니다."
          message="저장된 리포트는 '보관함'을 확인해주세요"
          buttonType="Outline"
          closeText="보관함 바로가기"
          confirmText="리포트 계속 확인"
          isModal={false}
          onCancel={() => setShowPopupSave(false)}
          onConfirm={() => setShowPopupSave(false)}
        />
      )}

      {showCreatePersonaPopup && (
        <PopupWrap
          Check
          title="NPS 분석을 시작합니다"
          message="페르소나 기반 NPS 분석을 진행하시겠습니까?"
          buttonType="Outline"
          closeText="취소"
          confirmText="시작하기"
          isModal={false}
          onCancel={() => {
            setShowCreatePersonaPopup(false);
            navigate("/Tool");
          }}
          onConfirm={handleConfirmCredit}
        />
      )}

      {showCreditPopup && (
        <PopupWrap
          Warning
          title="서비스 이용 안내"
          message="해당 서비스를 이용하시겠습니까?"
          buttonType="Outline"
          closeText="확인"
          isModal={false}
          onCancel={() => {
            setShowCreditPopup(false);
            navigate("/Tool");
          }}
          onConfirm={() => {
            setShowCreditPopup(false);
            navigate("/Tool");
          }}
        />
      )}

      {showPreviewPopup && (
        <>
          <StyledInterviewPopup>
            <div
              style={{
                maxWidth: "700px",
                width: "100%",
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                gap: "20px",
                padding: "32px 32px",
                borderRadius: "15px",
                background: "#FFFFFF",
                boxShadow: "4px 4px 30px rgba(0, 0, 0, 0.15)",
              }}
            >
              <div className="header">
                <H4
                  style={{
                    fontSize: "16px",
                    marginBottom: "16px",
                  }}
                >
                  디스플레이 콘텐츠 자세히 보기
                  <span
                    className="close"
                    onClick={() => setShowPreviewPopup(false)}
                  />
                </H4>
                {/* <div
                  style={{
                    width: "100%",
                    height: "1px",
                    backgroundColor: "#E0E4EB",
                    marginBottom: "16px",
                  }}
                /> */}
              </div>

              <div className="content" style={{ textAlign: "left" }}>
                <div style={{ marginBottom: "12px" }}>
                  <Body2
                    color="gray700"
                    style={{ fontWeight: "400", textAlign: "left" }}
                  >
                    콘텐츠 목적
                  </Body2>
                  <DetailBox>
                    <Body2
                      color="gray800"
                      style={{ fontWeight: "400", textAlign: "left" }}
                    >
                      {selectedPurposes.customerList}
                    </Body2>
                  </DetailBox>
                </div>

                {/* <div style={{ marginBottom: "12px" }}>
                  <Body2
                    color="gray700"
                    style={{ fontWeight: "400", textAlign: "left" }}
                  >
                    콘텐츠 방향성
                  </Body2>
                  <DetailContentBox>
                    <Body3 color="gray600">{contentTarget}</Body3>
                  </DetailContentBox>
                </div> */}

                <div>
                  <Body2
                    color="gray700"
                    style={{ fontWeight: "400", textAlign: "left" }}
                  >
                    콘텐츠 내용
                  </Body2>
                  <DetailContentBox>
                    <Body3
                      color="gray600"
                      style={{ fontWeight: "400", textAlign: "left" }}
                    >
                      {autoDisplayFileAnalysis?.detail}
                    </Body3>
                  </DetailContentBox>
                </div>
              </div>
            </div>
          </StyledInterviewPopup>
        </>
      )}
    </>
  );
};

export default PageCreateEducationContent;

const DesignAnalysisWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 100px;
  margin-top: 60px;
`;

const ConceptSelectorContainer = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 16px;
`;

const ConceptCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  border: 1px solid ${palette.outlineGray};
  border-radius: 10px;
  width: 400px;
`;

const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;

const ImagePreviewContainer = styled.div`
  position: relative;
  width: 100%;
  height: 200px; /* Adjust as needed */
  border-radius: 8px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const PreviewButton = styled.button`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  border-radius: 16px;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.3s ease;

  ${ImagePreviewContainer}:hover & {
    opacity: 1;
  }
`;

const InterviewModeSelection = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  justify-content: flex-start;
  margin-bottom: 48px;

  button {
    flex: 0 0 auto;
    max-width: 200px;
  }

  .button-container {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    margin-top: 20px;
  }
`;

export const CheckCircle = styled.input`
  appearance: none;
  display: block !important;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  cursor: pointer;

  background-image: ${(props) =>
    props.checked
      ? `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3E%3Ccircle cx='12' cy='12' r='12' fill='%23226FFF'/%3E%3Cpath d='M6.76562 12.4155L9.9908 15.6365L17.2338 8.36426' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`
      : `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3E%3Ccircle cx='12' cy='12' r='11.5' stroke='%23E0E4EB'/%3E%3C/svg%3E")`};
  transition: background-image 0.3s ease-in-out;

  + label {
    cursor: pointer;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;

    + label {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }
`;

const StyledInterviewPopup = styled(InterviewPopup)`
  .markdown-body {
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      margin-top: 0px;
      margin-bottom: 12px;
      color: ${palette.gray800};
      font-weight: 600;
    }
    p,
    li,
    span {
      line-height: 1.55;
    }
    p {
      margin-bottom: 8px;
    }
    h1 {
      font-size: 24px;
    }
    h2 {
      font-size: 20px;
    }
    h3 {
      font-size: 18px;
    }
  }
  .core-value-section h2:nth-of-type(4) ~ p:last-of-type {
    margin-bottom: 12px !important;
  }

  h2:nth-of-type(4) ~ h2:nth-of-type(5) {
    margin-top: 20px;
  }
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 20px;
  border: 1px solid ${palette.outlineGray};
  border-radius: 10px;
  // background: ${palette.gray100};
  width: 100%;
`;

const InfoContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const DeviceInfoBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  // padding: 12px 16px;
  border-radius: 6px;
  // margin-top: 8px;

  > * {
    white-space: nowrap;
  }

  > *:not(:last-child)::after {
    content: "|";
    margin-left: 8px;
    color: #e0e4eb;
  }
  // > *:not(:last-child):not(:nth-last-child(2))::after {
  //   content: "|";
  //   margin-left: 8px;
  //   color: #e0e4eb;
  // }
`;

const ContentAnalysisSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin: 24px 0 0px 0;
  width: 100%;
`;

const ContentOptionsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const FestivalInfoBox = styled.div`
  border: 1px solid ${palette.outlineGray};
  border-radius: 16px;
  padding: 24px;
  margin-top: 16px;
  min-width: 100%;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`;

const CompletionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin: 32px auto;
  text-align: center;
  width: 100%;
`;

const CompletionIcon = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: ${palette.primary};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CheckIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const CompletionMessage = styled.div`
  text-align: center;
  max-width: 400px;
`;

const DashedLine = styled.div`
  width: 100%;
  height: 1px;
  border-top: 2px solid ${palette.gray300};
  margin: 0px;
  margin-top: 32px;
  margin-bottom: 36px;
`;

const DetailBox = styled.div`
  background: ${palette.gray100};
  border-radius: 8px;
  padding: 12px 16px;
`;

const DetailContentBox = styled.div`
  background: ${palette.gray100};
  border-radius: 8px;
  padding: 12px 16px;
`;

const ContentConceptBox = styled.div`
  border: 1px solid ${palette.outlineGray};
  border-radius: 10px;
  min-width: 820px;
  overflow: hidden;
`;

const ContentConceptHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px 8px 20px;
  background: #f2f6ff;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom: none;
`;

const ConceptTitle = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: #090f15;
  line-height: 24px;
  font-family: Pretendard;
`;

const RegenerateButton = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0;
  background: transparent;
  color: #226fff;
  border: none;
  cursor: pointer;
  font-size: 15px;
  font-weight: 400;
  font-family: Pretendard;
  line-height: 22.5px;

  span {
    color: #226fff;
  }

  &:hover {
    opacity: 0.8;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const ContentConceptBody = styled.div`
  padding: 20px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;

  .markdown-body {
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      margin-top: 0px;
      margin-bottom: 12px;
      color: #090f15;
      font-weight: 400;
      font-family: Pretendard;
    }
    p,
    li,
    span {
      line-height: 1.55;
      color: #090f15;
      font-size: 19px;
      font-weight: 400;
      font-family: Pretendard;
      line-height: 28.5px;
    }
    p {
      margin-bottom: 8px;
    }
    h1 {
      font-size: 24px;
    }
    h2 {
      font-size: 20px;
    }
    h3 {
      font-size: 18px;
    }
  }
  .core-value-section h2:nth-of-type(4) ~ p:last-of-type {
    margin-bottom: 12px !important;
  }

  h2:nth-of-type(4) ~ h2:nth-of-type(5) {
    margin-top: 20px;
  }
`;

const TargetAudienceContainer = styled.div`
  width: 100%;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  display: inline-flex;
`;

const TargetAudienceGrid = styled.div`
  align-self: stretch;
  justify-content: flex-start;
  align-items: stretch;
  gap: 13px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  grid-template-rows: repeat(2, 1fr);
  max-width: 100%;
`;

const TargetAudienceButton = styled.button`
  padding: 20px 16px;
  background: ${(props) => (props.selected ? "#F2F6FF" : "white")};
  border-radius: 10px;
  border: 1px solid ${(props) => (props.selected ? "#226FFF" : "#E0E4EB")};
  justify-content: center;
  align-items: center;
  gap: 16px;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  transition: all 0.2s ease;
  min-height: 100px;

  &:hover {
    background: ${(props) => (props.selected ? "#F2F6FF" : "#F7F8FA")};
    border-color: ${(props) => (props.selected ? "#226FFF" : "#BCC4D0")};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  svg {
    path {
      stroke: ${(props) => (props.selected ? "#226FFF" : "#666666")};
    }
    rect {
      stroke: ${(props) => (props.selected ? "#226FFF" : "#666666")};
    }
  }
`;

const TargetAudienceIcon = styled.div`
  width: 44px;
  height: 44px;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 36px;
    height: 36px;
  }
`;

const TargetAudienceName = styled.span`
  color: ${(props) => (props.selected ? "#226FFF" : "#666666")};
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 600;
  line-height: 24px;
  word-wrap: break-word;
  text-align: center;
`;